import {request, _urlBrandTypes} from "../api";
import {BRAND_TYPES_CONSTS} from "../constants";
import {history} from "../../configs/history";
import {notificationSuccess} from "../../components/uiElements/Notifications";

export const GetBrandTypes = () => {
    const requestData = {
        url: _urlBrandTypes,
        token: true,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: BRAND_TYPES_CONSTS.GET_BRAND_TYPES,
                    payload: data
                });
            })
    }
};

export const GetBrandTypesById = (id) => {
    const requestData = {
        url: `${_urlBrandTypes}/${id}`,
        token: true,
        method: "GET",
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
               return res.data
            })
    }
};
export const DeleteBrandTypesById = id => {
    const requestData = {
        url: `${_urlBrandTypes}/${id}`,
        token: true,
        method: "DELETE",
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: BRAND_TYPES_CONSTS.DELETE_BRAND_TYPES_BY_ID,
                    payload: id
                });
            })
    }
};

export const CreateBrandTypes = data => {
    const requestData = {
        url: _urlBrandTypes,
        token: true,
        method: "POST",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: BRAND_TYPES_CONSTS.CREATE_BRAND_TYPES,
                    payload: res?.data
                });
                notificationSuccess({
                    description: "Տվյալները հաջողությամբ ստեղծվեց!"
                })
                history.push('/brandTypes')
            })
    }
};

export const UpdateBrandTypesById = (id, data) => {
    const requestData = {
        url: `${_urlBrandTypes}/${id}`,
        token: true,
        method: "PATCH",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: BRAND_TYPES_CONSTS.UPDATE_BRAND_TYPES,
                    payload: res?.data
                });
                notificationSuccess({
                    description: "Տվյալները հաջողությամբ փոփոխվեց!"
                })
                history.push('/brandTypes')
            })
    }
};

export const UpdateBrandTypesPositions = items => {
    const requestData = {
        url: _urlBrandTypes,
        token: true,
        method: "PUT",
        data: items
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                notificationSuccess({
                    description: "Տվյալները հաջողությամբ փոփոխվեց!"
                })
            })
    }
};
